
    import Vue from "vue";

    const END_POINT = "/staffRequirement";

    const getStaffRequirement = id => Vue.axios.get(END_POINT + "/" + id);

    const getAllStaffRequirements = data => Vue.axios.get(END_POINT, {params: data});

    const createStaffRequirement = staffRequirement => Vue.axios.post(END_POINT,  staffRequirement );

    const createAllStaffRequirements = StaffRequirements => Vue.axios.post(END_POINT + "/all",  StaffRequirements );

    const updateStaffRequirement = staffRequirement => Vue.axios.put(END_POINT  + "/" + staffRequirement.id,  staffRequirement );

    const deleteStaffRequirement = id => Vue.axios.delete(END_POINT  + "/" + id);

    export {
      getStaffRequirement,
      getAllStaffRequirements,
      createStaffRequirement,
      createAllStaffRequirements,
      updateStaffRequirement,
      deleteStaffRequirement
    };
    